import React from 'react';
const DesktopHeader = ({ onLogout }) => {
  return (
    <header className="sticky top-0 z-20 bg-white/80 backdrop-blur-sm border-b border-notion-border px-8 py-3 flex items-center justify-between">
      <div className="flex items-center gap-2 text-sm">
        <span className="text-notion-text-light">Workspace</span>
        <span className="text-notion-text-light">/</span>
        <span className="font-medium text-notion-text">Dashboard</span>
      </div>

      {/* Right-side actions removed for Dashboard (UI-only). Keep container for layout. */}
      <div className="flex items-center gap-4" aria-hidden>
        <div className="w-0 h-0" />
      </div>
    </header>
  );
};

export default DesktopHeader;
